import { Command } from 'ckeditor5/src/core';
import { findOptimalInsertionRange } from 'ckeditor5/src/widget';
export class OpenscopInsertCommand extends Command {
    execute(options) {
        const { editing, model } = this.editor;
        model.change(writer => {
            const iconElement = writer.createElement('icon', { icon: options?.icon });
            model.insertContent(iconElement);
            editing.view.focus();
        });
    }
    refresh() {
        const { model } = this.editor;
        const { document, schema } = model;
        // Determine if the cursor (selection) is in a position where adding a
        // icon is permitted. This is based on the schema of the model(s)
        // currently containing the cursor.
        const allowedIn = schema.checkChild(getParentElement(document.selection, model), 'icon');
        // If the cursor is not in a location where a icon can be added, return
        // null so the addition doesn't happen.
        this.isEnabled = allowedIn !== null;
    }
}
function getParentElement(selection, model) {
    const parent = findOptimalInsertionRange(selection, model).start.parent;
    if (parent.isEmpty && !parent.is('element', '$root')) {
        return parent.parent;
    }
    return parent;
}
